<template>
  <div>
    <slotBase :bg-grey="true" :footer-radius="true">
      <template v-slot:title>
        <titleBar :header-title="'Pembayaran'" @back="back" />
      </template>

      <template v-slot:content>
        <div class="main-content p-x-20">
          <cardPayment />
        </div>
      </template>
      <template v-slot:footer>
        <div class="d-flex justify-content-center align-items-center p-a-20">
          <button
            @click="handleButtonClick"
            class="btn btn-primary w-100"
            :disabled="btnBayar ? true : false"
          >
            <span
              class="spinner-border text-light f-16 spiner-border-sm"
              v-if="btnBayar"
            ></span>
            <span v-if="!btnBayar">Bayar & Nyalakan Mesin</span>
          </button>
        </div>
      </template>
    </slotBase>
  </div>
</template>

<script>
import slotBase from "@/components/slots/slotBase.vue";
import titleBar from "@/components/design/titleBar.vue";
import cardPayment from "../components/cardPayment.vue";
import { mapActions, mapState } from "vuex";

export default {
  name: "pembayaranLayanan",
  components: {
    slotBase,
    titleBar,
    cardPayment,
  },

  data() {
    return {
      btnBayar: false,
    };
  },

  computed: {
    ...mapState("scan", {
      dataPesanan: "dataPesanan",
      dataCustomer: "dataCustomer",
    }),
  },
  methods: {
    ...mapActions({
      postCreateSnapTransaksi: "scan/postCreateSnapTransaksi",
    }),
    async handleButtonClick() {
      this.btnBayar = true;
      let data = {
        id: this.dataCustomer.id,
        idcustomer: this.dataCustomer.idcustomer,
        idmesin: this.dataPesanan.idmesin,
        idoutlet: this.dataCustomer.idoutlet,
        idsnap_layanan: this.dataPesanan.idsnap_layanan,
        total: this.dataPesanan.total,
        grandtotal: this.dataPesanan.grandtotal,
      };
      try {
        const response = await this.postCreateSnapTransaksi(data);
        if (response.status === 200) {
          // console.log("POST request successful");
          this.$router.push({ name: "dashboardUtama" });
          this.$toast.success("Mesin Berhasil dinyalakan", {
            position: "top",
          });
        } else if (response.status != 200) {
          this.$router.push({ name: "dashboardUtama" });
          this.$toast.error(response.data.message, {
            position: "top",
          });
          this.btnBayar = false;
          // console.log("POST request failed:", response.data.message);
        }
      } catch (error) {
        console.error("Error in POST request:", error);
      }
    },
    back() {
      this.$router.replace({ name: "pilihEpay" });
    },
  },
};
</script>

<style scoped></style>
